import React from 'react';
import { useSelector } from 'react-redux';

interface ISidebarLeftProps {
  children: JSX.Element;
  style: React.CSSProperties;
}

const SidebarLeft = (props: ISidebarLeftProps) => {
  const { children, style } = props;
  const { sidebarLeft } = useSelector((state: any) => state.layoutState);

  return (
    <div
      id="box-sidebar-left"
      className={sidebarLeft ? 'open-sidebar' : ''}
      style={style}
      data-cy="SidebarLeft"
    >
      {children}
    </div>
  );
};

export default SidebarLeft;
